import React, { useState, useEffect } from 'react'

const ParticipantCounter = ({
    label,
    value,
    onChange,
    min,
    max
}) => {
    const [count, setCount] = useState(value);

    useEffect(() => {
        setCount(value);
    }, [value]);

    const incrementHandler = () => {
        if (count < max) {
            const newCount = Number(count) + 1;

            setCount(newCount)
            onChange(newCount)
        }
    }

    const decrementHandler = () => {
        if (count > min) {
            const newCount = Number(count) - 1;

            setCount(newCount)
            onChange(newCount)
        }
    }

    return (
        <div className="participants">
            <h4 className="trip-modal__title trip-modal__title--small participants__label">{label}</h4>
            <div className="participants__actions">
                <button
                    type="button"
                    onClick={decrementHandler}
                    disabled={count <= min}
                    className="animation-transform participants__btn participants__btn--minus"
                >-</button>
                <span className="participants__counter">{count}</span>
                <button
                    type="button"
                    onClick={incrementHandler}
                    disabled={count >= max}
                    className="animation-transform participants__btn participants__btn--plus"
                >+</button>
            </div>
        </div>
    )
}

export default ParticipantCounter;
